<fieldset>
  <legend aria-hidden="true"></legend>
  <div id="radio-options" class="list-custom" *ngIf="itens">
    <label class="list-custom__label" role="radio"
    *ngFor="let item of itens | filter: textSearch: fieldSearch : filterIncludes; trackBy:trackByKey;"
     [attr.aria-label]="item?.value"
    [attr.aria-checked]="selectedValue === item?.key"
    id="{{item?.key}}" tabindex="0">
      <span aria-hidden="true" class="list-custom__text list-custom--item">{{item?.value}}</span>
      <input [disabled]="disabled" type="radio" name="radio" [checked]="selectedValue === item?.key" [attr.aria-checked]="selectedValue === item?.key" [attr.value]="item?.key" 
      class="list-custom__radio list-custom--item" (change)="changeValue($event, item?.value, item?.ariaLabel, item?.key, item);" aria-hidden="true">
      <div class="list-custom__radio-custom" aria-hidden="true">
        <div class="radio-inner" aria-hidden="true"></div>
      </div>
    </label>
  </div>
</fieldset>